'use client';

import { useEffect } from 'react';

export default function PresenceHeartbeat() {
    useEffect(() => {
        // Send immediate heartbeat on mount
        sendHeartbeat();

        // Setup interval
        const intervalId = setInterval(sendHeartbeat, 30 * 1000); // 30 seconds

        return () => clearInterval(intervalId);
    }, []);

    const sendHeartbeat = async () => {
        try {
            await fetch('/api/presence', { method: 'POST' });
        } catch (e) {
            // Ignore errors (user might be offline or logged out)
        }
    };

    return null; // Invisible component
}
